import { Route } from '@angular/router';
import { SharedFeatureResetPasswordComponent } from '@luggagehero/shared-feature-reset-password';

import { HomeComponent } from './home/home.component';
import { NoAccessComponent } from './no-access/no-access.component';

//
// Lazy loaded modules are handled here; users are handled in the module itself and then imported in the web.module
//
export const routes: Array<Route> = [
  { path: 'no-access', component: NoAccessComponent },
  { path: 'home', component: HomeComponent },
  { path: 'reset-password', component: SharedFeatureResetPasswordComponent },
  {
    path: '',
    loadChildren: () => import('./shop-manager/shop-manager.module').then((m) => m.ShopManagerLoaderModule),
  },
];
